import React, { Component } from 'react'
import css from './style.css'
import { Grid, GridItem } from '../grid'

export default function ScaleGroupComponent (ScaleItem) {
  class ScaleGroup extends Component {
    render () {
      const renderScaleGroup = (group) => {
        let numGroups = group.elements.length
        return (
          <Grid nopad>
            {group.elements.map((item, index) => <ScaleItem key={index} {...this.props} item={item} numItemsInGroup={numGroups} index={index} />)}
          </Grid>
        )
      }
      const totalItems = this.props.elements.reduce((acc, group) => { return acc + group.elements.length }, 0)
      return (
        <div className={css.container}>
          <Grid nopad>
            {this.props.elements.map((group, index) => (
              <GridItem key={index} nopad col={`${group.elements.length}/${totalItems}`} customStyle={css.itemGroup}>
                {renderScaleGroup(group)}
                <Grid nopad>
                  <GridItem nopad col='1/1' customStyle={css.description}>
                    {group.description}
                  </GridItem>
                </Grid>
              </GridItem>
            ))}
          </Grid>
        </div>
      )
    }
  }

  return ScaleGroup
}



// WEBPACK FOOTER //
// ./src/components/scale/scale_group.js